export default __webpack_public_path__ + "static/media/CyberBot.8d43f638.mp4";